(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ConfirmationHotelEdit',
	};

	// Main form element
	var $form = $('form[name=ConfirmationHotelEdit]');

	// Serialized form data


	$(document)
	.ready(
		function documentReady() {
			Adzuki.Form.registerForm(form);
		}
	);

	form.load = function load()
	{
		var priceContainer  = $form.find('.pricing');
		var calculateFields = $(priceContainer).find('.calculate-commission');

		$(calculateFields)
			.on(
				'change',
				function calc() {
					calculateCommission();
				}
			)
		;

		$(calculateFields)
			.on(
				'keyup',
				function calc() {
					calculateCommission();
				}
			)
		;

		function calculateCommission() {
			var price      = $(priceContainer).find('.price').val();
			// var taxes      = $(priceContainer).find('.taxes').val();
			var commission = $(priceContainer).find('.commission-percent').val();
			var totalField = $(priceContainer).find('.commission-total');

			var total = (parseFloat(commission) * 0.01) * (parseInt(price));

			total = Number(total).toFixed(2);

			$(totalField).val(total);
		}

	};


}(jQuery, window.Adzuki || {}));
